import { render, staticRenderFns } from "./DashboardV2Overview.vue?vue&type=template&id=fdb1b392&scoped=true&"
import script from "./DashboardV2Overview.vue?vue&type=script&lang=js&"
export * from "./DashboardV2Overview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2Overview.vue?vue&type=style&index=0&id=fdb1b392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb1b392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VIcon,VRow})
